'use strict';

import React from 'react';

import { OnSchedUtils } from "../../../utils";
import { GetAvailability } from '../../../actions/availabilityActions';


const SearchDropdownResult = ({ element, name, value, set, searching, setInput, date, setAvailability, setTimezone}) => {
  const onclick = e => {
    OnSchedUtils.Loading(element, true);
    
    GetAvailability(element, date, value)
      .then(resp => {
        OnSchedUtils.Loading(element, false);
        setAvailability(resp);
        setTimezone(value);
        set({ name, value });
        setInput(name);
        searching(false);
      })
  }

  return (
    <li onClick={onclick} className="SearchDropdownResult onsched-secondary-background-color-hover">{name}</li>
  )
}

export default SearchDropdownResult;
